<template>
  <div class="bank-details" :class="isEditing">
    <div v-if="!editing" class="bank-details__content">
      <h3 class="title--m">{{ getUiString(['claim_details','details','bank_details','title']) }}</h3>
      <div class="row" v-for="row in displayFields" :key="row.id">
        <div class="cell" v-for="cell in row.cells" :key="cell.key">
          <div class="label">{{ cell.label }}</div>
          <div class="value" v-if="!!cell.value">{{ cell.value }}</div>
          <div class="value" v-else>
            <a
              v-if="canEditBankData"
              class="link"
              @click.prevent="editing = true"
            >{{ getUiString(['form_fields', 'not_yet_supplied']) }}</a>
            <span v-else>{{ getUiString(['form_fields', 'not_yet_supplied']) }}</span>
          </div>
        </div>
      </div>
      <div class="message message--warning" v-if="isInvalid">
        <lennoc-icon image="warning" />
        <span>{{ getUiString(['claim_details','details','bank_details','bankaccount_incorrect']) }}</span>
      </div>
      <div
        class="event-host"
        @mouseenter.stop="showCannotEditMessage = true"
        @mouseleave.stop="showCannotEditMessage = false"
      >
        <button v-if="canEditBankData" class="link link--edit" @click.prevent="editing = true" :disabled="!isEditable">
          <lennoc-icon image="edit" />
          <span>{{ getUiString(['claim_details','details','bank_details','edit_button']) }}</span>
        </button>
      </div>
      <lennoc-tool-tip v-if="messageVisible" :error="true">{{ notEditableMessage }}</lennoc-tool-tip>
    </div>
    <edit-bank-details
      v-if="editing"
      :initialFields="bankaccountFields"
      @cancel="cancelEdit"
      @ready="initFields"
    ></edit-bank-details>
    <lennoc-spinner v-show="busy" isFullscreen="false" />
  </div>
</template>

<script>
import EditBankDetails from '@/components/claims/EditBankDetails.vue'
import { mapGetters } from 'vuex'
import { splitIntoColumns } from '@/utils/formComposition.js'

export default {
  name: 'ClaimBankDetails',
  data () {
    return {
      editing: false,
      busy: false,
      bankaccountFields: [],
      showCannotEditMessage: false
    }
  },
  components: {
    EditBankDetails
  },
  computed: {
    ...mapGetters({
      notEditableMessage: 'claim/isNotEditableMessage',
      isEditable: 'claim/isEditableByMe',
      claimClosed: 'claim/isClaimClosed',
      getUiString: 'uistrings/getUiString',
      paymentMethod: 'claim/paymentMethod',
      bankAccount: 'claim/bankAccount',
      paypalAccount: 'claim/paypalAddress'
    }),
    messageVisible () {
      return this.showCannotEditMessage && !this.isEditable
    },
    canEditBankData () {
      return this.isEditable && !this.claimClosed
    },
    displayFields () {
      const fields = this.bankaccountFields.map(f => {
        return {
          key: f,
          label: this.getUiString(['form_fields', f]),
          value: this.getFieldValue(f)
        }
      })
      let index = 0
      return splitIntoColumns(fields).map(r => {
        return { id: `row_${index++}`, cells: r }
      })
    },
    isInvalid () {
      if (this.paymentMethod === 'PayPal') {
        return this.bankAccount.Valid === false && !!this.paypalAccount
      }
      return this.bankAccount.Valid === false &&
      this.bankaccountFields.filter(f => f !== 'CountryCode' && !!this.bankAccount[f]).length > 0
    },
    isEditing () {
      return this.editing ? 'bank-details--slim' : ''
    }
  },
  mounted () {
    this.initFields()
  },
  methods: {
    cancelEdit () {
      this.editing = false
      this.initFields()
    },
    initFields () {
      if (this.paymentMethod === 'PayPal') {
        this.bankaccountFields = ['PayPalEMailAccount']
        this.editing = false
      } else {
        this.busy = true
        const countryCode = this.bankAccount.CountryCode || 'NL'
        this.$store
          .dispatch('claim/getRequiredBankAccountFields', countryCode)
          .then(result => {
            this.bankaccountFields = [
              'CountryCode',
              ...result.BankAccountField
            ]
          })
          .finally(() => {
            this.editing = false
            this.busy = false
          })
      }
    },
    getFieldValue (key) {
      if (key === 'CountryCode') {
        return this.$store.getters.getCountryName(this.bankAccount[key])
      } else if (key === 'PayPalEMailAccount') {
        return this.paypalAccount
      }
      return this.bankAccount[key]
    }
  }
}
</script>
